module.exports = __webpack_public_path__ + "img/b3.596d8647.png";